document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".acordion .trigger");

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function () {

      const tree = this.nextElementSibling;
      // 開閉アイコン部分を取得
      const icon = this.querySelector(".open-close");

      if (tree.classList.contains("open")) {
        tree.style.maxHeight = null;     // 高さをリセット
        tree.classList.remove("open");   // クラス削除
        this.classList.remove("active"); // 見出しのactive削除
        icon.textContent = "open";       // アイコンの文字変更
      } else {

        tree.classList.add("open");      // 開いた状態クラス付与
        this.classList.add("active");    // 見出しをactiveに
        tree.style.maxHeight = tree.scrollHeight + "px"; // 高さ指定してアニメーション
        icon.textContent = "close";      // アイコンの文字変更
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const h1 = document.querySelector('h1.page-title');
  if (!h1) return;

  // ページスラッグを取得
  const path = window.location.pathname;
  const slug = path.replace(/^\/|\/$/g, '').replace(/[^a-zA-Z0-9\-]/g, '');
  const pageClass = slug === '' ? 'page-home' : `page-${slug}`;

  // ラッパーdivを作成
  const outer = document.createElement('div');
  outer.classList.add(pageClass);

  // innerを作成してh1を包む
  const inner = document.createElement('div');
  inner.classList.add('inner');
  h1.parentNode.insertBefore(outer, h1);
  outer.appendChild(inner);
  inner.appendChild(h1);

  console.log(`Created wrapper: <div class="${pageClass}"><div class="inner">...</div></div>`);
});
